import { render } from "./manage-logo.vue?vue&type=template&id=9524f7a8"
import script from "./manage-logo.vue?vue&type=script&lang=js"
export * from "./manage-logo.vue?vue&type=script&lang=js"

import "./manage-logo.vue?vue&type=style&index=0&id=9524f7a8&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__